import React from "react";

import File from "@peracto/peracto-editor-ui/dist/File";
import Checkbox from "@peracto/peracto-editor-ui/dist/Checkbox";

const VideoForm = ({
  onChange,
  state: {
    url = "",
    poster = "",
    autoPlay = false,
    loop = false,
    controls = false,
    showControlsOnHover = false,
    muted = false,
    playsInline = false,
  },
}) => {
  return (
    <>
      <File
        label="Video URL"
        value={url}
        onChange={(value) => onChange({ url: value })}
      />

      <File
        label="Video thumbnail"
        value={poster}
        onChange={(value) => onChange({ poster: value })}
      />

      <Checkbox
        label="Autoplay"
        checked={autoPlay}
        help={
          autoPlay
            ? "Autoplaying videos are always muted and play inline, as browsers block autoplay otherwise."
            : ""
        }
        onChange={(e) =>
          // Browsers only allow muted videos to autoplay, and iOS also requires playsinline
          onChange(
            e.target.checked
              ? { autoPlay: true, muted: true, playsInline: true }
              : { autoPlay: false }
          )
        }
      />

      <Checkbox
        label="Loop"
        checked={loop}
        onChange={(e) => onChange({ loop: e.target.checked })}
      />

      <Checkbox
        label="Show Controls"
        checked={controls}
        onChange={(e) => onChange({ controls: e.target.checked })}
      />

      {!controls && (
        <Checkbox
          label="Show controls on hover"
          checked={showControlsOnHover}
          help="On mobile, controls are always shown when this is ticked."
          onChange={(e) => onChange({ showControlsOnHover: e.target.checked })}
        />
      )}

      {!autoPlay && (
        <>
          <Checkbox
            label="Mute"
            checked={muted}
            onChange={(e) => onChange({ muted: e.target.checked })}
          />

          <Checkbox
            label="Play Inline"
            checked={playsInline}
            onChange={(e) => onChange({ playsInline: e.target.checked })}
          />
        </>
      )}
    </>
  );
};

export default VideoForm;
